module.exports = __webpack_public_path__ + "img/gdq_gbt95_1985.prt.8e6e5a86.jpg";